import { Injectable, QueryList, ViewContainerRef, ComponentFactoryResolver, ComponentRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IDBService } from './indexdb/idb.service';
import { LoggingService } from './logging/logging.service';
import { IUrlOptions } from './../models/rest.caller.model';
import { RemoteService } from './remote.service';
import { DomStorageFallbackService } from './DomStorageFallback.service';
import { LoggingConstants } from './../constants/logging-constant';
import { PageConstants } from './../constants/page.constants';
import { Observable } from 'rxjs';
import { UIStorageService } from '../services/storage.service';
import { BrandingService } from './branding.service';
import { AppUtility } from '../utils/utility';
import { GenericService } from './generic.service';
import { dynamicComponentConstants } from './../constants/dynamicComponent-constant';

@Injectable()
export class DynamicComponentService {
  public ALIGHT_REQUEST_HEADER = 'alightRequestHeader';
  public selectorName;
  public isSelecotrFound = false;
  public pageUtility: any;
  public pageImpGroups = [];
  assetValueMap: any;
  pageComponentJson: string;

  factories: any[];

  templateContent: QueryList<ViewContainerRef>;

  af_enabled: any;

  // private restrictedComponentName: string = 'RestrictedComponent';
  /* istanbul ignore next */
  constructor(

    private componentFactoryResolver: ComponentFactoryResolver,

    private activatedRoute: ActivatedRoute,

    private router: Router,

    private idBService: IDBService,

    private domStorageFB: DomStorageFallbackService,

    private remoteService: RemoteService,

    private logService: LoggingService,

    private uiStorageService: UIStorageService,

    private brandingService: BrandingService,

    private appUtility: AppUtility,

    private genericService: GenericService

  ) {

    this.af_enabled = this.domStorageFB.getItem('AF_SWITCH_ON', '', true);
  }

  /**
   * Method to read Assetgroup using name found from current Page
   * Read AssetGroup from IDBStore or put a call for that AssetGroup to microservice
   * Iterate TemplateContent and add components to it dynamically.
   * @param templateContent
   */
  /* istanbul ignore next */
  public dynamicComponents(templateContent: QueryList<ViewContainerRef>, assetgroup?: string) {
    this.templateContent = templateContent;
    if (LoggingService.uConsole) {
      console.log('templateContent in dynamic component', this.templateContent);
    }
    let agName;
    /** Page Assetgroup read - start */
    try {
      if (this.idBService.getDBName() && this.idBService.getDBName().name === 'Upoint_DB') {
        /**IDB service Logic Start */
        this.idBService.getRecordFromObjStore('NGFirst_Pages', 'agPageData').subscribe(
          (pageData) => {
            try {
              if (assetgroup !== null && assetgroup !== undefined) {
                agName = 'UPN_AFPAGE_' + assetgroup;
              } else {
                agName = this.getGroupNameFromRoute();
              }
              this.getAssetGroupFromSevice(agName, true);
            } catch (Error) {
              if (LoggingService.uConsole) {
                console.log(Error);
              }
            }
          },
          (error) => {
            this.logService._error(JSON.stringify(error), 'service invocation failed with response', LoggingConstants.ERROR, 'Home Page Dynamic Service');
            if (LoggingService.uConsole) {
              console.log('DCS : Error Triggered while fetching data from IndexDB From AssetGroup :' + error);
            }
          });
        /**IDB Service Logic End */
      } else {
        if (assetgroup !== null && assetgroup !== undefined) {
          agName = 'UPN_AFPAGE_' + assetgroup;
        } else {
          agName = this.getGroupNameFromRoute();
        }
        /** Load Page Data From service and render Dynamic Components */
        this.getAssetGroupFromSevice(agName, false);
      }

    } catch (Error) {
      if (LoggingService.uConsole) {
        console.log(Error);
      }
    }
    /** Page Assetgroup read - end */
  }

  /**
   *
   * Method : IterateFactories and Compareit templateContentItem
   * if both matches then load it to that templateContentItem
   * @param componentWithAutoId
   * @param templateContentItem
   * @param loadingIndex
   */
  /* istanbul ignore next */
  loadComponent(componentWithAutoId, templateContentItem, loadingIndex) {
    try {
      this.factories = this.getFactoryForAllComponents();
      let factoriesKeys: any = Array.from(this.getFactoryForAllComponents().keys());
      let factoriesValues: any = Array.from(this.getFactoryForAllComponents().values());
      // this.viewContainerRef.clear();
      let componentName = componentWithAutoId.substring(0, componentWithAutoId.indexOf(':#:'));
      if (LoggingService.uConsole) {
        console.log('loadCopmponent componentname ' + componentName);
      }
      let attributesObj = componentWithAutoId.substring(componentWithAutoId.indexOf(':#:') + 3, componentWithAutoId.length);
      if (LoggingService.uConsole) {
        console.log('loadCopmponent attributesObj ' + attributesObj);
      }
      let autoId = 'aid';
      this.selectorName = componentName;
      dynamicComponentConstants.MODULES.forEach((i) => {
        if (i.type === componentName) {
          this.selectorName = i.selector;
          if (LoggingService.uConsole) {
            console.log('loadComponent fn -> selectorName ->', this.selectorName);
          }
        }
      });

      factoriesKeys.forEach((factory, index) => {
        /* istanbul ignore next */
        if (LoggingService.uConsole) {
          console.log('loadComponent fn -> factory.name ->', factory.name, ' componentName ->', componentName, ' factory ->', factory);
        }
        if (factory.name === componentName) {
          this.isSelecotrFound = true;
          let componentFactory = this.componentFactoryResolver.resolveComponentFactory(factory);
          let componentRef: ComponentRef<any>;
          componentRef = this.templateContent.toArray()[loadingIndex].createComponent(componentFactory);
          /** Logic  to associate Attributes with component - dynamically */
          if (attributesObj !== null) {
            let autoIdFound = false;
            attributesObj = attributesObj.replace(/'/g, '"');
            attributesObj = JSON.parse(attributesObj);
            let attributeKey;
            if (Object.keys(attributesObj).length > 0) {
              Object.keys(attributesObj).forEach(key => {
                if (!autoIdFound && key === autoId) { autoIdFound = true; }
                attributeKey = this.getAbbreviations(key);
                componentRef.location.nativeElement.setAttribute(attributeKey, attributesObj[key]);
              });
            }
            if (Object.keys(attributesObj).length <= 0 || !autoIdFound) {
              attributeKey = this.getAbbreviations(autoId);
              componentRef.location.nativeElement.setAttribute(attributeKey, componentFactory.selector.toString());
            }
          }
          return;
        }
      });
      if (this.isSelecotrFound === false) {
        factoriesValues.forEach((factory, index) => {
          if (LoggingService.uConsole) {
            console.log('loadComponent fn -> factory.selector ->', factory.selector, ' selectorName ->', this.selectorName, ' factory.componentType ->', factory.componentType);
          }
          /* istanbul ignore next */
          if (factory.selector === this.selectorName) {
            let componentFactory = this.componentFactoryResolver.resolveComponentFactory(factory.componentType);
            let componentRef: ComponentRef<any>;
            componentRef = this.templateContent.toArray()[loadingIndex].createComponent(componentFactory);
            /** Logic  to associate Attributes with component - dynamically */
            if (attributesObj !== null) {
              let autoIdFound = false;
              attributesObj = attributesObj.replace(/'/g, '"');
              attributesObj = JSON.parse(attributesObj);
              let attributeKey;
              if (Object.keys(attributesObj).length > 0) {
                Object.keys(attributesObj).forEach(key => {
                  if (!autoIdFound && key === autoId) { autoIdFound = true; }
                  attributeKey = this.getAbbreviations(key);
                  componentRef.location.nativeElement.setAttribute(attributeKey, attributesObj[key]);
                });
              }
              if (Object.keys(attributesObj).length <= 0 || !autoIdFound) {
                attributeKey = this.getAbbreviations(autoId);
                componentRef.location.nativeElement.setAttribute(attributeKey, componentFactory.selector.toString());
              }
            }
            return;
          }
        });
      }
    } catch (Error) {
      if (LoggingService.uConsole) {
        console.log('DCS : loadComponent Method Failed ' + Error);
      }
    }
  }

  /**
   * Return Array of all factories regiestered
   */
  /* istanbul ignore next */
  getFactoryForAllComponents() {
    return this.factories = this.componentFactoryResolver['_factories'];
  }

  /**
   * Execute Page Component Json to Load Component Dynamically
   */
  /* istanbul ignore next */
  private executePageComponent(pageComponentJsonObj: any) {
    if (pageComponentJsonObj !== null && pageComponentJsonObj !== undefined) {
      this.templateContent.forEach((templateContentItem, templateContentIndex) => {
        let templateKey: any = templateContentItem.element.nativeElement.parentNode.id || templateContentItem.element.nativeElement.parentElement.id;
        pageComponentJsonObj.forEach((columnComponent, index) => {
          if (columnComponent.columnNo === templateKey) {
            let pageName = '';
            if (this.getCurrentPage() === 'login') {
              pageName = 'Login';
            }
            if (this.getCurrentPage() === 'home') {
              pageName = 'Home';
            }
            let assetGrpName = 'P2E_PORTLET_' + pageName;
            columnComponent.components.forEach((component, index1) => {
              let instanceidValue = component['instanceId'];
              if (instanceidValue) {
                let instanceIdReplaced = instanceidValue.replace(/-/g, '_HYPHEN_');

                this.pageImpGroups.push({ 'assetGroup': assetGrpName, 'asset': instanceIdReplaced });
              }
            });
            if (this.pageImpGroups) {
              if (!this.domStorageFB.getItem('portletEligibility') || this.domStorageFB.getItem('portletEligibility') === undefined) {
                this.genericService.resolveAssetOfAssetGroup(this.pageImpGroups).subscribe((assetValueMap: any) => {
                  this.assetValueMap = JSON.parse(assetValueMap._body)[0].asset[assetGrpName];
                  if (this.getCurrentPage() === 'home') {
                    this.domStorageFB.setItem('portletEligibility', assetValueMap._body);
                  }
                  columnComponent.components.forEach((component, index1) => {
                    let instanceidValue = component['instanceId'];

                    let instanceIdReplaced = instanceidValue.replace(/-/g, '_HYPHEN_');
                    if (this.assetValueMap && this.assetValueMap[instanceIdReplaced] && this.assetValueMap[instanceIdReplaced].assetValue === 'false') {
                      console.log('this ' + instanceIdReplaced + 'ignored');
                    } else {
                      this.renderComponent(component, templateContentItem, templateContentIndex);
                    }
                  });
                });
              } else {
                this.assetValueMap = JSON.parse(this.domStorageFB.getItem('portletEligibility'))[0].asset[assetGrpName];
                columnComponent.components.forEach((component, index1) => {
                  let instanceidValue = component['instanceId'];
                  let instanceIdReplaced = instanceidValue.replace(/-/g, '_HYPHEN_');
                  if (this.assetValueMap && this.assetValueMap[instanceIdReplaced] && this.assetValueMap[instanceIdReplaced].assetValue === 'false') {
                    console.log('this ' + instanceIdReplaced + 'ignored');
                  } else {
                    this.renderComponent(component, templateContentItem, templateContentIndex);
                  }
                });
              }
            } else {
              columnComponent.components.forEach((component, index1) => {
                this.renderComponent(component, templateContentItem, templateContentIndex);
              });
            }
          }
        });
      });
    }
  }

  /**
   * Execute Page Component Json to Load Component Dynamically
   */
  /* istanbul ignore next */
  private executePageComponentJson(pageComponentJsonObj: any) {
    if (pageComponentJsonObj !== null && pageComponentJsonObj !== undefined) {
      this.templateContent.forEach((templateContentItem, templateContentIndex) => {
        let templateKey: any = templateContentItem.element.nativeElement.parentNode.id || templateContentItem.element.nativeElement.parentElement.id;
        let jsonPageComponent: any = JSON.parse(pageComponentJsonObj);
        if (templateKey in jsonPageComponent) {
          jsonPageComponent[templateKey].forEach((componentWithAutoId, index) => {
            this.loadComponent(componentWithAutoId, templateContentItem, templateContentIndex);
          });
        }
      });
    }
  }

  /**
   * Construct GroupName from Route
   */
  /* istanbul ignore next */
  public getGroupNameFromRoute(): any {
    let agName = window.location.href;
    if (agName.indexOf('?') > 0) {
      agName = agName.split('?')[0];
      agName = agName.split('/web/')[1].split('/')[1];
      // agName = agName.substring(agName.lastIndexOf('/') + 1, agName.length);
    } else {
      agName = agName.split('/web/')[1].split('/')[1];
      // agName = agName.substring(agName.lastIndexOf('/') + 1, agName.length);
    }
    if (LoggingService.uConsole) {
      console.log('DynamicComponentService: Route Name Found is : ' + agName);
    }
    agName = 'UPN_AFPAGE_' + agName;
    if (LoggingService.uConsole) {
      console.log('DynamicComponentService: agName in dynamic component' + agName);
    }
    return agName;
  }
  /**
   * Execute Service all for AssetGroup return Response or Store it in IndexDB
   */
  /* istanbul ignore next */
  private getAssetGroupFromSevice(agName: string, addDataToStore: boolean) {
    let pageGroupUrl = 'channel/widgetconfigurations/channel/configurationList/get';
    let lineage = this.uiStorageService.getClientId() + '_1.0';
    if (this.appUtility.isPreAuth()) {
      pageGroupUrl = 'channel/widgetconfigurations/channel/configurationList/get/public';
      if (LoggingService.uConsole) {
        console.log('DynamicComponentService : Inside Pre-Auth Case with pageGroupURL :' + pageGroupUrl + ' Lineage : ' + lineage);
      }
      /* lineage = JSON.parse(this.domStorageFB.getItem('lr_json_data')).lineage.toString(); */
      lineage = this.uiStorageService.getLineage();
    }
    const options: IUrlOptions = {
      restOfUrl: '',
      endPoint: pageGroupUrl,
      isSecure: true,
      contentType: 'application/json'
    };
    let pageImpGroups = [];
    pageImpGroups.push({ 'assetGroup': agName, 'resolveAll': 'true' });
    let requestBody = {
      'lineage': lineage,
      'locale': 'en_US',
      'operation': 'configset',
      'assetKeys': pageImpGroups

    };
    if (LoggingService.uConsole) {
      console.log('DynamicComponentService : AssetGroup Service requestBody :' + requestBody);
    }
    return this.remoteService.request('post', options, requestBody).subscribe((respData) => {
      if (addDataToStore) {
        if (this.idBService.getDBName() && this.idBService.getDBName().name === 'Upoint_DB') {
          this.idBService.addRecordsInObjStore('NGFirst_Pages', JSON.parse(respData._body), 'agPageData').
            subscribe((responseData) => {
              if (LoggingService.uConsole) {
                console.log('AssetGroup Data Used Successfully from IndexStore!!');
              }
              let json = JSON.parse(respData._body);

              if (json[0].asset[agName].hasOwnProperty('pageComponentJson')) {
                //   this.pageUtility = json[0];
                if (json[0].asset[agName].pageComponentJson) {
                  this.pageComponentJson = json[0].asset[agName].pageComponentJson.assetKey;
                  this.executePageComponentJson(this.pageComponentJson);
                }
              } else {
                // this.renderRestrictedComponent(this.templateContent);
              }
            },
            (error) => {
              if (LoggingService.uConsole) {
                console.log('DynamicComponentService : Error Triggered while Adding AssetGroup data to Index DB : ' + error);
              }
            });
        } else {
          let json = JSON.parse(respData._body);
          if (json[0].asset[agName].hasOwnProperty('pageComponentJson')) {
            this.pageUtility = json[0];
            if (json[0].asset[agName].pageComponentJson) {
              this.pageComponentJson = json[0].asset[agName].pageComponentJson.assetKey;
              this.executePageComponentJson(this.pageComponentJson);
            }
          } else {
            // this.renderRestrictedComponent(this.templateContent);
          }
        }
      } else {
        let json = JSON.parse(respData._body);
        if (json[0].asset[agName].hasOwnProperty('pageComponentJson')) {
          //   this.pageUtility = json[0];
          if (json[0].asset[agName].pageComponentJson) {
            this.pageComponentJson = json[0].asset[agName].pageComponentJson.assetKey;
            this.executePageComponentJson(this.pageComponentJson);
          }
        } else {
          // this.renderRestrictedComponent(this.templateContent);
        }
      }

    },
      (error) => {
        this.logService._error(JSON.stringify(error), 'service invocation failed with response in dynamicComponent', LoggingConstants.ERROR, 'Home Page Dynamic Service');
        if (LoggingService.uConsole) {
          console.log('AssetGroup call failed to invoke in Dynamic Component for AssetGroup: ' + agName + 'Error: ' + error);
        }
      });
  }

  /**
   * This method will return abbrevivated fullForm or Shorthands used in AssetGroup Json
   * @param shortForm
   */
  /* istanbul ignore next */
  private getAbbreviations(shortForm: string) {
    if (PageConstants[shortForm]) {
      return PageConstants[shortForm];
    }
    return shortForm;
  }

  /**
   * Method to render RestrictedComponent when Eligibility fails for user
   * @param templateContent
   */
  /* istanbul ignore next */
  /* private renderRestrictedComponent(templateContent: QueryList<ViewContainerRef>) {
    this.templateContent.forEach((templateContentItem, templateContentIndex) => {
      let templateKey: any = templateContentItem.element.nativeElement.parentNode.id || templateContentItem.element.nativeElement.parentElement.id;
      /* let restrictedtemplateJsonValueArry = [];
       let restrictedtemplateJsonValue = this.restrictedComponentName + ":#:{'aid':'" + templateKey + "'}";
       restrictedtemplateJsonValueArry.push(restrictedtemplateJsonValue);
       let restrictedJsonObj:any = {
         templateKey : restrictedtemplateJsonValueArry
       }; when you uncomment whole function and comment here
      let restrictedPageCompJsonObj = `{"${templateKey}":["${this.restrictedComponentName}:#:{'aid':'${templateKey}'}"]}`;
      let jsonPageComponent: any = JSON.parse(restrictedPageCompJsonObj);
      jsonPageComponent[templateKey].forEach((componentWithAutoId, index) => {
        this.loadComponent(componentWithAutoId, templateContentItem, templateContentIndex);
      });
    });
  } */

  /**
  * Execute Service all for AssetGroup return Response or Store it in IndexDB
  */

  /* istanbul ignore next */
  public breadcrumbLinkTitle(): any {
    let urlTitle = this.router.url.toString();
    // let urlTitle= window.location.href;
    if (urlTitle.indexOf('?') > 0) {
      urlTitle = urlTitle.split('?')[0];
      urlTitle = urlTitle.substring(urlTitle.lastIndexOf('/') + 1, urlTitle.length);
    } else {
      urlTitle = urlTitle.substring(urlTitle.lastIndexOf('/') + 1, urlTitle.length);
    }
    return urlTitle;
  }

  /* istanbul ignore next */
  public getPageUtility(): any {
    return this.pageUtility;
  }

  public initializePageComponents(gaDynamicPageName?: any) {
    if (LoggingService.uConsole) {
      console.log('outside initializepagecomponent method with page name' + this.getCurrentPage());
      console.log(this.appUtility.isLiferay() + 'liferay status');
    }
    if (!this.appUtility.isLiferay()) {
      if (LoggingService.uConsole) {
        console.log('inside initializepagecomponent method with page name' + this.getCurrentPage());
        console.log(this.appUtility.isLiferay() + 'liferay status');
      }
      document.title = 'UpointBaseApp';
    }
    this.initializepagecomponentsAndBranding(true, gaDynamicPageName);
  }

  /* istanbul ignore next */
  public initializepagecomponentsAndBranding(loadBranding, gaDynamicPageName?: any) {
    if (this.af_enabled) {
      // UFD-258: GA tracking for child routing
      let gaJson = JSON.parse(this.domStorageFB.getItem('ga_json'));
      if (gaJson) {
        if (gaDynamicPageName !== '' && gaDynamicPageName !== null && gaDynamicPageName !== undefined) {
          gaJson['gaPageName'] = gaDynamicPageName;
          this.domStorageFB.setItem('ga_json', JSON.stringify(gaJson));
        } else {
          gaJson['gaPageName'] = this.fetchDefaultPageName(this.genericService.getOrgName());
          this.domStorageFB.setItem('ga_json', JSON.stringify(gaJson));
        }
      }
      this.loadCustomJS();
      // if (this.domStorageFB.getItem('AF_IVA_ENABLED', '', true) === 'true') {
      // this.getIVAFlag();
      // }
      if (loadBranding) {
        this.brandingService.getSiteBrandingUrl();
      }
      this.appUtility.toggleRTLClass();
    }
  }

  /* istanbul ignore next */
  loadCustomJS() {
    if (this.af_enabled) {
      const app_url = this.domStorageFB.getItem('app_url', '', );
      if (app_url) {
        let source = app_url + 'al-assets/js/customJS.js';
        let headTag = document.getElementsByTagName('head')[0];
        let scriptTag = document.createElement('script');
        scriptTag.setAttribute('type', 'text/javascript');
        scriptTag.setAttribute('language', 'javascript');
        scriptTag.setAttribute('async', 'true');
        scriptTag.setAttribute('src', source);
        scriptTag.setAttribute('charset', 'UTF-8');
        headTag.appendChild(scriptTag);
      }
    }
  }
   /* istanbul ignore next */
  public initializeThrivepagecomponentsAndBranding(loadBranding) {
    if (this.af_enabled) {
      this.loadThriveCustomJS();
      // if (this.domStorageFB.getItem('AF_IVA_ENABLED', '', true) === 'true') {
      // this.getIVAFlag();
      // }
      if (loadBranding == null || loadBranding === undefined || loadBranding === true) {
        this.brandingService.getSiteBrandingUrl();
      }
      this.appUtility.toggleRTLClass();
    }
  }
  /* istanbul ignore next */
  loadThriveCustomJS() {
    if (this.af_enabled) {
      const app_url = this.domStorageFB.getItem('app_url', '', );
      if (app_url) {
        let source = app_url + 'al-assets/js/thriveCustomJS.js';
        if (LoggingService.uConsole) {
          console.log('AngularCore | DynamicComponentService | loadCustomJS() - dynamiclyy add the script - ' + source);
        }

        let headTag = document.getElementsByTagName('head')[0];
        let scriptTag = document.createElement('script');
        scriptTag.setAttribute('type', 'text/javascript');
        scriptTag.setAttribute('language', 'javascript');
        scriptTag.setAttribute('async', 'true');
        scriptTag.setAttribute('src', source);
        scriptTag.setAttribute('charset', 'UTF-8');
        headTag.appendChild(scriptTag);
      }
    }
  }

  /* istanbul ignore next */
  public fetchDefaultPageName(orgName) {
    let pageName = window.location.href;
    let page, pg;
    if (pageName.indexOf('?') > 0) {
      page = pageName.split('?');
      pg = page[0].substr(page[0].lastIndexOf('/') + 1, page[0].length);
    } else {
      pg = pageName.substr(pageName.lastIndexOf('/') + 1, pageName.length);
    }
    return pg;
  }

  /* istanbul ignore next */
  getIVAFlag() {
    if (this.af_enabled) {
      let pageGroupUrl = 'channel/widgetconfigurations/channel/configurationList/get';
      let lineage = this.genericService.getClientId.toString();
      let preAuthFlag = false;
      let includeIVAJs = 'false';
      if (!this.domStorageFB.getItem('alightSecureSessionToken', '', true) || !this.domStorageFB.getItem('alightPersonSessionToken', '', true)) {
        pageGroupUrl = 'channel/widgetconfigurations/channel/configurationList/get/public';
        lineage = JSON.parse(this.domStorageFB.getItem('lr_json_data')).lineage.toString();
        preAuthFlag = true;
      }
      // pageGroupUrl = 'al-assets/iva.json';
      const options: IUrlOptions = {
        restOfUrl: '',
        endPoint: pageGroupUrl,
        isSecure: true,
        contentType: 'application/json'
      };
      let expression = [];
      expression.push({ 'name': 'IS_PRE_AUTH_IVA_ENABLED', 'type': 'regular' });
      expression.push({ 'name': 'IS_IVA_ENABLED', 'type': 'regular' });
      expression.push({ 'name': 'IS_IVA_PPT_ELIG', 'type': 'regular' });
      const requestBody = {
        'lineage': lineage,
        'locale': 'en_US',
        'operation': 'configset',
        'exprKeys': expression
      };

      this.fetchData(options, requestBody).subscribe((respData) => {
        // return this.fetchData().subscribe((respData) => {
        if (respData !== undefined) {
          let isPreAuthSwitchOn = respData[0].expr.IS_PRE_AUTH_IVA_ENABLED;
          this.domStorageFB.setItem('isPreAuthSwitchOn', isPreAuthSwitchOn);
          if (!preAuthFlag && respData[0].expr.IS_IVA_ENABLED) {
            includeIVAJs = respData[0].expr.IS_IVA_PPT_ELIG;
            if (includeIVAJs) {
            }
          } else if (preAuthFlag && isPreAuthSwitchOn) {
            includeIVAJs = 'true';
          }
          this.domStorageFB.setItem('includeIVAJs', includeIVAJs);
        }
      },
        (error) => {
          if (LoggingService.uConsole) {
            console.log('error while fetching iva flag ' + Error);
          }
        });
    }
  }

  /* istanbul ignore next */
  fetchData(options, requestBody): Observable<any> {
    return this.remoteService.request('post', options, requestBody).map((res: any) => res.json());
  }

  /* istanbul ignore next */
  public updatePageNameForSession() {
    if (LoggingService.uConsole) {
      console.log('Dynamic Component AfterView Init Called');
    }
    let curPage = this.router.url.toString();
    if (curPage.indexOf('?') > 0) {
      curPage = curPage.split('?')[0];
      curPage = curPage.substring(curPage.lastIndexOf('/') + 1, curPage.length);
    } else {
      curPage = curPage.substring(curPage.lastIndexOf('/') + 1, curPage.length);
    }
    let reqHeader = JSON.parse(this.domStorageFB.getItem(this.ALIGHT_REQUEST_HEADER));
    if (reqHeader.channelRequestData) {
      let crData = reqHeader.channelRequestData;
      let start = crData.indexOf('URL::');
      let end = crData.indexOf('::', start + 5);
      if (LoggingService.uConsole) {
        console.log('curPage :', curPage);
      }
      if (start !== -1 && end !== -1) {
        let pg = crData.substring(start + 5, end);
        const oldStr = 'URL::' + pg + '::';
        crData = crData.replace(oldStr, 'URL::' + curPage + '::');
        reqHeader.channelRequestData = crData;
        this.domStorageFB.setItem(this.ALIGHT_REQUEST_HEADER, JSON.stringify(reqHeader), '', true);
      }
    }
  }

  /* istanbul ignore next */
  processUrlForIntranet(event): any {


    let pageGroupUrl = 'channel/widgetconfigurations/channel/configurationList/get';
    let lineage = this.uiStorageService.getClientId() + '_1.0';
    const options: IUrlOptions = {
      restOfUrl: '',
      endPoint: pageGroupUrl,
      isSecure: true,
      contentType: 'application/json'
    };

    let pageImpGroups = [];
    let expression = [];

    pageImpGroups.push({ 'assetGroup': 'CORE_INTRANET_ALERT_ASST_GRP', 'resolveAll': 'true' });
    expression.push({ 'name': 'intranet_expr', 'type': 'regular' });

    let requestBody = {
      'lineage': lineage,
      'locale': 'en_US',
      'operation': 'configset',
      'assetKeys': pageImpGroups,
      'exprKeys': expression
    };


    return this.remoteService.request('post', options, requestBody).map((res: Response) => {
      return res;
    });
  }

  /* istanbul ignore next */
  public pageUtilityAssest() {
    if (LoggingService.uConsole) {
      console.log('templateContent in dynamic component', this.templateContent);
    }
    /** Page Assetgroup read - start */
    try {
      if (this.idBService.getDBName() && this.idBService.getDBName().name === 'Upoint_DB') {
        /**IDB service Logic Start */
        this.idBService.getRecordFromObjStore('PageUtilityAssests', 'pageutilities').subscribe(
          (pageData) => {
            try {
              this.getPageUtilityAssetGroupSevice(true);
            } catch (Error) {
              if (LoggingService.uConsole) {
                console.log(Error);
              }
            }
          },
          (error) => {
            this.logService._error(JSON.stringify(error), 'service invocation failed with response', LoggingConstants.ERROR, 'Home Page Dynamic Service');
            if (LoggingService.uConsole) {
              console.log('DCS : Error Triggered while fetching data from IndexDB From AssetGroup :' + error);
            }
          });
        /**IDB Service Logic End */
      } else {
        /** Load Page Data From service and render Dynamic Components */
        this.getPageUtilityAssetGroupSevice(false);
      }
    } catch (Error) {
      if (LoggingService.uConsole) {
        console.log(Error);
      }
    }
    /** Page Assetgroup read - end */
  }

  /* istanbul ignore next */
  private getPageUtilityAssetGroupSevice(addDataToStore: boolean) {
    let pageGroupUrl = 'channel/widgetconfigurations/channel/configurationList/get';
    let lineage = this.uiStorageService.getClientId() + '_1.0';
    if (!this.domStorageFB.getItem('alightSecureSessionToken', '', true)) {
      pageGroupUrl = 'channel/widgetconfigurations/channel/configurationList/get/public';
      if (LoggingService.uConsole) {
        console.log('DynamicComponentService : Inside Pre-Auth Case with pageGroupURL :' + pageGroupUrl + ' Lineage : ' + lineage);
      }
      /* lineage = JSON.parse(this.domStorageFB.getItem('lr_json_data')).lineage.toString(); */
      lineage = this.uiStorageService.getLineage();
    }
    const options: IUrlOptions = {
      restOfUrl: '',
      endPoint: pageGroupUrl,
      isSecure: true,
      contentType: 'application/json'
    };
    let pageImpGroups = [];
    pageImpGroups.push({ 'assetGroup': 'PRINT_ASSET_GROUP', 'resolveAll': 'true' });
    let pageParamGroups = [];
    pageParamGroups.push({ 'name': 'PAGE_UTILITY_GROUP.BREADCRUMB.IS_SUPPORTED' });
    pageParamGroups.push({ 'name': 'PAGE_UTILITY_GROUP.PRINT.IS_SUPPORTED' });

    let requestBody = {
      'lineage': lineage,
      'locale': 'en_US',
      'operation': 'configset',
      'assetKeys': pageImpGroups,
      'paramKeys': pageParamGroups
    };
    if (LoggingService.uConsole) {
      console.log('DynamicComponentService : AssetGroup Service requestBody :' + requestBody);
    }

    return this.remoteService.request('post', options, requestBody).subscribe((respData) => {
      if (addDataToStore) {
        this.idBService.addRecordsInObjStore('PageUtilityAssests', JSON.parse(respData._body), 'pageutilities').
          subscribe((responseData) => {
            if (LoggingService.uConsole) {
              console.log('AssetGroup Data Used Successfully from IndexStore!!');
            }
            let json = JSON.parse(respData._body);

            if (json[0]) {
              this.pageUtility = json[0];
            }
          },
          (error) => {
            if (LoggingService.uConsole) {
              console.log('DynamicComponentService : Error Triggered while Adding AssetGroup data to Index DB : ' + error);
            }
          });
      } else {
        let json = JSON.parse(respData._body);
        if (json[0]) {
          this.pageUtility = json[0];
        }
      }

    },
      (error) => {
        this.logService._error(JSON.stringify(error), 'service invocation failed with response in dynamicComponent', LoggingConstants.ERROR, 'Home Page Dynamic Service');
        if (LoggingService.uConsole) {
          console.log('AssetGroup call failed to invoke in Dynamic Component for AssetGroup: ' + error);
        }
      });
  }

  /* istanbul ignore next */
  public getCurrentPage() {
    let curPage = window.location.href;
    if (curPage.indexOf('?') > 0) {
      curPage = curPage.split('?')[0];
      curPage = curPage.split('/web/')[1].split('/')[1];
    } else {
      curPage = curPage.split('/web/')[1].split('/')[1];
    }
    return curPage;
  }

  /* istanbul ignore next */
  public loadDynamicComponents(templateContent: QueryList<ViewContainerRef>) {
    this.loadDynamicComponentsWithJson(templateContent, null);
  }

  /* istanbul ignore next */
  public loadDynamicComponentsWithJson(templateContent: QueryList<ViewContainerRef>, pageLayoutJsonData: any) {
    this.templateContent = templateContent;
    if (LoggingService.uConsole) {
      console.log('templateContent in dynamic component', this.templateContent);
    }
    /** Page Assetgroup read - start */
    try {
      let agName = this.getGroupNameFromRoute();
      this.getDynamicComponentsFromSevice(agName, false, pageLayoutJsonData);
    } catch (Error) {
      if (LoggingService.uConsole) {
        console.log(Error);
      }
    }
    /** Page Assetgroup read - end */
  }


  /* istanbul ignore next */
  private getDynamicComponentsFromSevice(agName: string, addDataToStore: boolean, pageLayoutJsonData: any) {
    let pageName = this.getCurrentPage();
    if (pageLayoutJsonData !== undefined && pageLayoutJsonData !== null && pageLayoutJsonData !== '') {
      if (pageLayoutJsonData.hasOwnProperty('pagelayout')) {
        if (pageLayoutJsonData.pagelayout) {
          this.pageComponentJson = pageLayoutJsonData.pagelayout.layoutColumns;
          this.executePageComponent(this.pageComponentJson);
        }
      }
    } else {
      let layoutEndPoint = 'channel/clientappconfigurations/upoint/pagelayout/pagename/' + pageName;
      const options: IUrlOptions = {
        restOfUrl: '',
        endPoint: layoutEndPoint,
        isSecure: true,
        contentType: 'application/json'
      };
      return this.remoteService.getRequest(options, agName).subscribe(respData => {
        let json = respData;
        if (json.hasOwnProperty('pagelayout')) {
          if (json.pagelayout) {
            this.pageComponentJson = json.pagelayout.layoutColumns;
            this.executePageComponent(this.pageComponentJson);
          }
        }
      }, error => {
        this.logService._error(JSON.stringify(error), 'LayOut Service call error', LoggingConstants.ERROR, 'Dynamic Component');
      });
    }
  }
  /* istanbul ignore next */
  public loadPageLayout() {
    let pageName = this.getCurrentPage();
    let afPageName = this.getGroupNameFromRoute();
    // Remove the sessionStorage value for afPageName to prevent the empty page laod
    if (this.domStorageFB.getItem(afPageName)) {
      this.domStorageFB.removeItem(afPageName);
    }
    // let layoutEndPoint = 'http://localhost:4200/al-assets/data/mockLayout.json';
    let layoutEndPoint = 'channel/clientappconfigurations/upoint/pagelayout/pagename/' + pageName;
    const options: IUrlOptions = {
      restOfUrl: '',
      endPoint: layoutEndPoint,
      isSecure: true,
      contentType: 'application/json'
    };
    this.remoteService.getRequest(options, afPageName).subscribe(respData => {
      let json = respData;
      if (json.pagelayout) {
        let layout = json.pagelayout['layOutName'];
        this.domStorageFB.setItem(afPageName, layout);
      }
    }, error => {
      this.logService._error(JSON.stringify(error), 'LayOut Service call error', LoggingConstants.ERROR, 'Dynamic Component');
    });
  }

  /**
    *
    * Method : IterateFactories and Compareit templateContentItem
    * if both matches then load it to that templateContentItem
    * @param componentWithAutoId
    * @param templateContentItem
    * @param loadingIndex
    */
  /* istanbul ignore next */
  renderComponent(component, templateContentItem, loadingIndex) {
    try {
      this.factories = this.getFactoryForAllComponents();
      // this.viewContainerRef.clear();
      let componentName = component.componentName;
      if (LoggingService.uConsole) {
        console.log('loadCopmponent componentname ' + componentName);
      }
      // let attributesObj = componentWithAutoId.substring(componentWithAutoId.indexOf(':#:') + 3, componentWithAutoId.length);
      // if (LoggingService.uConsole) {
      //   console.log('loadCopmponent attributesObj ' + attributesObj);
      // }
      // let autoId = 'aid';
      this.selectorName = componentName;
      dynamicComponentConstants.MODULES.forEach((i) => {
        if (i.type === componentName) {
          this.selectorName = i.selector;
          if (LoggingService.uConsole) {
            console.log('renderComponent fn -> selectorName ->', this.selectorName);
          }
        }
      });
      // DCH-4796
      // Show third-party-widget instead of al-content-default, when content name is THIRD_PARTY_LEGAL_DISCLAIMER
      if (componentName === 'al-content-default' && component.webContentName && component.webContentName === 'THIRD_PARTY_LEGAL_DISCLAIMER' && this.appUtility.isPostAuth()) {
        componentName = 'al-third-party-legal-disclaimer-widget';
        this.selectorName = componentName;
        if (LoggingService.uConsole) {
          console.log('renderComponent fn -> switch al-content-default -> al-third-party-legal-disclaimer-widget');
        }
      }
      this.factories.forEach((factory, index) => {
        if (LoggingService.uConsole) {
          console.log('loadComponent fn -> factory.name ->', factory.name, ' componentName ->', componentName, ' factory ->', factory);
        }
        /* istanbul ignore next */
        if (factory.name === componentName) {
          this.isSelecotrFound = true;
          let componentFactory = this.componentFactoryResolver.resolveComponentFactory(factory);
          let componentRef: ComponentRef<any>;
          componentRef = this.templateContent.toArray()[loadingIndex].createComponent(componentFactory);
          /** Logic  to associate Attributes with component - dynamically */
          let attributeKey;
          if (Object.keys(component).length > 0) {
              Object.keys(component).forEach(key => {
                if (key !== 'componentName') {
                  attributeKey = this.getAbbreviations(key);
                  componentRef.location.nativeElement.setAttribute(attributeKey, component[key]);
                }
              });
            }
          return;
        }
      });
      if (this.isSelecotrFound === false) {
        this.factories.forEach((factory, index) => {
          if (LoggingService.uConsole) {
            console.log('renderComponent fn -> factory.selector ->', factory.selector, ' selectorName ->', this.selectorName, ' factory.componentType ->', factory.componentType);
          }
          /* istanbul ignore next */
          if (factory.selector === this.selectorName) {
            let componentFactory = this.componentFactoryResolver.resolveComponentFactory(factory.componentType);
            let componentRef: ComponentRef<any>;
            componentRef = this.templateContent.toArray()[loadingIndex].createComponent(componentFactory);
            /** Logic  to associate Attributes with component - dynamically */
            let attributeKey;
            if (Object.keys(component).length > 0) {
                Object.keys(component).forEach(key => {
                  if (key !== 'componentName') {
                    attributeKey = this.getAbbreviations(key);
                    componentRef.location.nativeElement.setAttribute(attributeKey, component[key]);
                  }
                });
              }
            return;
          }
        });
      }
    } catch (Error) {
      if (LoggingService.uConsole) {
        console.log('DCS : loadComponent Method Failed ' + Error);
      }
    }
  }

 /* istanbul ignore next */
  public loadScript(wcName, widgetName) {
    let intervalLifecycle;
    let counter = 0;
    let maxCounter = 100;
    intervalLifecycle = setInterval(() => {
      counter = counter + 1;
      if (counter > maxCounter) {
        clearInterval(intervalLifecycle);
        return;
      }
      if (sessionStorage.getItem('serviceClients') && (sessionStorage.getItem('serviceClients') !== undefined && sessionStorage.getItem('serviceClients') !== 'undefined' && sessionStorage.getItem('serviceClients') !== null && sessionStorage.getItem('serviceClients') !== 'null')) {
        let serviceClientsNewobj = JSON.parse(sessionStorage.getItem('serviceClients'));
        if (serviceClientsNewobj && serviceClientsNewobj.clientsetup && serviceClientsNewobj.clientsetup.activeProfile) {
          clearInterval(intervalLifecycle);
          if (sessionStorage.getItem('app_url') && (sessionStorage.getItem('app_url') !== undefined && sessionStorage.getItem('app_url') !== 'undefined' && sessionStorage.getItem('app_url') !== null && sessionStorage.getItem('app_url') !== 'null')) {
            const app_url = sessionStorage.getItem('app_url');
            if (app_url) {
              // e.g. wc_url = https://upoint-dv.alight.com
              // const wc_url = new URL(app_url).origin;
              let wc_url = '';
              let urlArr = app_url.split('/');
              if (urlArr.length >= 3) {
                wc_url = urlArr[0] + '//' + urlArr[2];
              }
              // e.g. resolved_url = https://upoint-dv.alight.com/search-widget/1.0/Search.js

              let resolved_url;
              const isIE = this.appUtility.getBrowser();
              if (this.getLifecycle()) {
                let version = this.getWCVersion(widgetName);
                if (version) {
                  let finalUrl = app_url.split('/UPoint');
                  if (isIE === 'ie11') {
                    resolved_url = finalUrl[0] + '/UPoint/UPN-WC/' + widgetName + '/' + version + '/' + wcName + '_es5' + '.js';
                  } else {
                    resolved_url = finalUrl[0] + '/UPoint/UPN-WC/' + widgetName + '/' + version + '/' + wcName + '.js';
                  }
                }
              } else {
                if (isIE === 'ie11') {
                  resolved_url = wc_url + '/' + widgetName + '/' + wcName + '_es5' + '.js';
                } else {
                  resolved_url = wc_url + '/' + widgetName + '/' + wcName + '.js';
                }
              }

              const content = document.head;
              if (content && resolved_url) {
                this.removejsfile(wcName);
                const script = document.createElement('script');
                script.src = resolved_url;
                script.charset = 'UTF-8';
                if (isIE === 'ie11') {
                  script.setAttribute('nomodule', '');
                  script.setAttribute('defer', '');
                } else {
                  script.type = 'module';
                }
                script.onerror = () => console.error(`error loading ${resolved_url}`);
                content.appendChild(script);
              }
            }
        }
        }
      }
    }, 100);
  }

/* istanbul ignore next */
public loadNgScripts(wcName, dialogName, widgetName, callback?) {
  /* const getapp_url = this.domStorageFB.getItem('app_url', '');
  if (getapp_url) {
    const newapp_url = new URL(getapp_url).origin;
    const path = '/primeng-wc/al-assets/js/ng/';
    let nativeshim = newapp_url + path + 'native-shim.js';
    let browserpolyfill = newapp_url + path + 'browser-polyfill.min.js';
    let rxjsumd = newapp_url + path + 'rxjs.umd.min.js';
    let coreumd = newapp_url + path + 'core.umd.min.js';
    let commonumd = newapp_url + path + 'common.umd.min.js';
    let commonhttp = newapp_url + path + 'common-http.umd.min.js';
    let compilerumd = newapp_url + path + 'compiler.umd.min.js';
    let elementsumd = newapp_url + path + 'elements.umd.min.js';
    let routerumd = newapp_url + path + 'router.umd.min.js';
    let formsumd = newapp_url + path + 'forms.umd.min.js';
    let animationsumd = newapp_url + path + 'animations.umd.min.js';
    let animationsbrowser = newapp_url + path + 'animations-browser.umd.min.js';
    let platformbrowser = newapp_url + path + 'platform-browser.umd.min.js';
    let platformbrowseranimations = newapp_url + path + 'platform-browser-animations.umd.min.js';

    let wc_url = newapp_url + '/' + widgetName + '/' + wcName + '.js';

    let jsListArr = [nativeshim, browserpolyfill, rxjsumd, coreumd, commonumd, commonhttp, compilerumd, elementsumd, routerumd, formsumd, animationsumd, animationsbrowser,
      platformbrowser, platformbrowseranimations, wc_url];

    let loader = function (src, handler) {
      // tslint:disable-next-line:no-shadowed-variable
      let getScriptTag = function (src) {
        let scripts = document.getElementsByTagName('script');
        for (let i = 0; i < scripts.length; i++) {
          if (scripts[i].getAttribute('src') === src) {
            return scripts[i];
          } else {
            return null;
          }
        }
      };

      let script = getScriptTag(src);
      if (script === null) {
        script = document.createElement('script') as HTMLScriptElement;
        script.src = src;
        let head = document.getElementsByTagName('head')[0];
        (head || document.body).appendChild(script);
      }
      script.onload = script.onload = function () {
        script.onload = null;
        handler();
      };
    };
    (function run() {
      if (jsListArr.length !== 0) {
        loader(jsListArr.shift(), run);
      } else {
        callback && callback();
      }
    })();
  }*/
}

/* istanbul ignore next */
getLifecycle() {
  if (sessionStorage.getItem('serviceClients')) {
    let serviceClientsobj = sessionStorage.getItem('serviceClients');
    let serviceClientsNewobj = JSON.parse(serviceClientsobj);
    if (serviceClientsNewobj && serviceClientsNewobj.clientsetup && serviceClientsNewobj.clientsetup.activeProfile) {
      if (serviceClientsNewobj.clientsetup.activeProfile === 'int') {
        return false;
      } else {
        return true;
      }
    }
  }
}

/* istanbul ignore next */
getWCVersion(wcName) {
    let wcVersionsObj = sessionStorage.getItem('wcVersions');
    console.log('wcVersionsObj value -> ' + wcVersionsObj);
    if (wcVersionsObj) {
      let wcVersions = JSON.parse(wcVersionsObj);
      if (console) {
        console.log('wcVersions value -> ' + wcVersions);
      }
      let keys = Object.keys(wcVersions);
      for (let i = 0; i < keys.length; i++) {
        if (keys[i] === wcName) {
          // console.log(keys[i] + ' getWCVersion -> ' + wcVersions[keys[i]]);
          return wcVersions[keys[i]];
        }
      }
    }
  }
/* istanbul ignore next */
removejsfile(filename) {
  let targetattr = 'src';
  let fileName = filename + '.js';
  let allsuspects = document.querySelectorAll('script');
  for (let i = allsuspects.length; i >= 0; i--) { // search backwards within nodelist for matching elements to remove
    if (allsuspects[i] && allsuspects[i].getAttribute(targetattr) !== null && allsuspects[i].getAttribute(targetattr).indexOf(fileName) !== -1) {
      allsuspects[i].parentNode.removeChild(allsuspects[i]);
    }
  }
  }
}


